import { Menu, Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { TypographyButton } from "../../../components/SignUp/styled";
import { Colors } from "../../../components/Form/Button";

export const CompanyUserAndEmailWrapper = styled(Grid)(() => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const Divider = styled("hr")(() => ({
  margin: "7px 0",
}));

export const GridItemContainer = styled(Grid)(() => ({}));

export const GridItemLink = styled(Grid, {
  shouldForwardProp: (props) => props !== "isLogout",
})(({ isLogout }: { isLogout: boolean }) => ({
  paddingTop: "5px",
  paddingBottom: isLogout ? 0 : "5px",
}));

export const UserProfileEmail = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  color: "#465869",
}));

export const UserProfileImage = styled("img")(() => ({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
}));

export const UserProfileMenuHeader = styled(Grid)(() => ({
  padding: "8px",
  gap: "24px",
}));

export const UserProfileName = styled("p")(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "16px",
  color: "#465869",
  margin: 0,
}));

export const SectionTitle = styled("label")(() => ({
  fontFamily: "Inter",
  fontWeight: 500,
  fontSize: "12px",
  color: "#475467",
  letterSpacing: 0.48,
  textTransform: "uppercase",
  marginTop: "12px",
  marginBottom: "15px",
}));

export const ButtonLink = styled(TypographyButton, {
  shouldForwardProp: (props) => props !== "isLogout",
})(({ isLogout }: { isLogout: boolean }) => ({
  backgroundColor: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  color: isLogout ? Colors.ERROR.background.hoverColor : Colors.NOT_SELECTED.text.color,
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  "&:hover": {
    color: isLogout ? Colors.ERROR.background.hoverColor : "",
  },
}));

const styles = makeStyles(() => ({
  menuPaperProps: {
    width: "320px",
    marginTop: "50px",
    marginLeft: "-17px",
  },
  menuOptionsPaperProps: {
    width: "320px",
  },
}));

export default styles;
